import { render, staticRenderFns } from "./MsgPublish.vue?vue&type=template&id=e428f9ce&"
import script from "./MsgPublish.vue?vue&type=script&lang=ts&"
export * from "./MsgPublish.vue?vue&type=script&lang=ts&"
import style0 from "./MsgPublish.vue?vue&type=style&index=0&id=e428f9ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports